import { facebookWhite } from 'UI/components/Svg/svgs';

export const EMAIL_LINK = 'hi@yellow.systems';

export const SOCIAL_MEDIA = {
  linkedin: {
    id: 'linkedin',
    title: 'LinkedIn',
    iconDark: 'linkedinFilled',
    iconLight: 'linkedinWhite',
    link: 'https://www.linkedin.com/company/yellow-systems',
  },
  facebook: {
    id: 'facebook',
    title: 'Facebook',
    iconDark: 'facebookDark',
    iconLight: 'facebookWhite',
    link: 'https://www.facebook.com/yellow.systems/',
  },
  twitter: {
    id: 'twitter',
    title: 'Twitter',
    iconDark: 'twitterFilled',
    iconLight: 'twitterWhite',
    link: 'https://mobile.twitter.com/yellow_systems',
  },
  dribbble: {
    id: 'dribbble',
    title: 'Dribbble',
    iconDark: 'dribbbleFilled',
    iconLight: 'dribbbleWhite',
    link: 'https://dribbble.com/yellow_systems',
  },
  behance: {
    id: 'behance',
    title: 'Behance',
    iconDark: 'behanceFilled',
    iconLight: 'behanceWhite',
    link: 'https://www.behance.net/yellow_systems',
  },
  youtube: {
    id: 'youtube',
    title: 'YouTube',
    iconDark: 'youtubeSocialFilled',
    iconLight: 'youtubeWhite',
    link: 'https://www.youtube.com/@yellowsystems9900',
  },
  instagram: {
    id: 'instagram',
    title: 'Instagram',
    iconDark: 'instagramFilled',
    iconLight: 'instagramWhite',
    link: 'https://www.instagram.com/yellow.systems/',
  },
};

export const PHONE_NUMBER = {
  us: '+1 (940) 601 6017',
};

export const ADDRESS = {
  us: {
    addressCountry: 'USA',
    addressLocality: 'San Francisco',
    streetAddress: '44 Tehama St',
    postalCode: '94105',
  },
  ar: {
    addressCountry: 'Argentina',
    addressLocality: 'Buenos Aires',
    streetAddress: 'Av. Corrientes 1312',
    postalCode: 'C1043ABN',
  },
  pl: {
    addressCountry: 'Poland',
    addressLocality: 'Warszawa',
    streetAddress: 'Grzybowska 62',
    postalCode: '00-855',
  },
  cy: {
    addressCountry: 'Cyprus',
    addressLocality: 'Larnaca',
    streetAddress: 'Agias Faneromenis, 143, Flat 201',
    postalCode: '6031',
  },
};

export const PLACEMENT_DATA = {
  USA: [
    `${ADDRESS.us.streetAddress} ${ADDRESS.us.addressLocality} ${ADDRESS.us.postalCode}`,
  ],
  Poland: [
    `${ADDRESS.pl.addressLocality} ${ADDRESS.pl.postalCode}`,
    ADDRESS.pl.streetAddress,
  ],
  Argentina: [
    `${ADDRESS.ar.streetAddress} ${ADDRESS.ar.postalCode}`,
    ADDRESS.ar.addressLocality,
  ],
};
